import React from "react";
import { SidebarFormProps } from "./SidebarForm";
import { useTranslations } from "../../../../contexts";
import { DesignerSectionHeading } from "./DesignerSectionHeading";

type SidebarColorsProps = SidebarFormProps;

export const SidebarColors: React.FC<SidebarColorsProps> = (props) => {
  const i18n = useTranslations();
  const onColorChange = (
    params: Pick<SidebarColorsProps["form"], "color" | "color_weight">
  ) => {
    props.setForm({
      ...props.form,
      ...params,
    });
  };

  const baseColors = [
    { class: "gray-500", display: "gray" },
    { class: "red-500", display: "red" },
    { class: "orange-500", display: "orange" },
    { class: "yellow-500", display: "yellow" },
    { class: "green-500", display: "green" },
    { class: "blue-500", display: "blue" },
    { class: "indigo-500", display: "indigo" },
    { class: "purple-500", display: "purple" },
    { class: "pink-500", display: "pink" },
  ];

  const shadeOptions = [100, 200, 300, 400, 500, 600, 700, 800, 900];
  const selectedColor = props.form.color;
  const showShades = selectedColor && selectedColor !== "gray-900";

  return (
    <div id="color-form" className="border-b p-6">
      <DesignerSectionHeading
        className="pb-4"
        title={i18n.color}
        helpLabel={`${i18n.designerHelpFor} ${i18n.color}`}
        helpText={i18n.designerColorHelp}
      />
      <div className="flex flex-col gap-6">
        {/* Primary Colors */}
        <div className="flex flex-wrap gap-3">
          {baseColors.map((color) => {
            const [base] = color.class.split("-");
            return (
              <div
                key={color.class}
                className={`w-10 h-10 rounded-lg cursor-pointer bg-${
                  color.class
                } ${
                  props.form.color === base && props.form.color_weight === 500
                    ? "outline outline-2 outline-offset-2 outline-black"
                    : color.class === "gray-900" &&
                      props.form.color === "gray-900"
                    ? "outline outline-2 outline-offset-2 outline-black"
                    : ""
                }`}
                onClick={() => {
                  if (color.class === "gray-900") {
                    onColorChange({ color: "gray-900", color_weight: 900 });
                  } else {
                    onColorChange({ color: base, color_weight: 500 });
                  }
                }}
                title={color.display}
              />
            );
          })}
        </div>

        {showShades && (
          <div className="flex flex-wrap gap-3">
            {shadeOptions.map((shade) => (
              <div
                key={shade}
                className={`w-10 h-10 rounded-lg cursor-pointer bg-${selectedColor}-${shade} ${
                  props.form.color_weight === shade
                    ? "outline outline-2 outline-offset-2 outline-black"
                    : ""
                }`}
                onClick={() =>
                  onColorChange({ color: selectedColor, color_weight: shade })
                }
                title={`${selectedColor}-${shade}`}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
